const i18nService = {
  defaultLanguage: "de",

  languages: [
    {
      lang: "de",
      name: "Deutsch",
      flag: process.env.BASE_URL + "svg/flags/162-germany.svg"
    },
    {
      lang: "en",
      name: "English",
      flag: process.env.BASE_URL + "svg/flags/226-united-states.svg"
    }
  ],

  /**
   * Keep the active language in the localStorage
   * @param lang
   */
  setActiveLanguage(lang) {
    localStorage.setItem('eventboxAdminLanguage', lang);
  },

  /**
   * Get the current active language
   * @returns {string | string}
   */
  getActiveLanguage() {
    return localStorage.getItem('eventboxAdminLanguage') || this.defaultLanguage;
  }
};

export default i18nService;
